import { RemoteNotification } from "@blacknut/javascript-sdk/dist";
import { Button } from "@blacknut/react-sdk/dist";
import { AppLayout, useLayout } from "core";
import React from "react";
import { useAppNavigation } from "src/utils/Navigation/useAppNavigation";
import { ReactComponent as Close } from "../../../assets/dist/ic_close.svg";
import dimens from "../../../theme/dimens";
import styles from "./styles.module.scss";
import clsx from "clsx";

const BannerNotification = (props: {
  notification?: RemoteNotification;
  message?: string;
  onClose: () => void;
}) => {
  const { notification, onClose, message } = props;
  const layout = useLayout();
  const { navigate } = useAppNavigation();
  const onClickLink = async (event: React.MouseEvent<unknown>) => {
    if (notification?.link) {
      if (notification.link.startsWith(`${process.env.REACT_APP_DEEPLINK_SCHEME}://`)) {
        navigate(
          notification.link.replace(`${process.env.REACT_APP_DEEPLINK_SCHEME}://`, "/"),
        );
      } else {
        window.open(notification.link, "_blank");
      }
    }
    event.preventDefault();
    event.stopPropagation();
    setTimeout(() => {
      onClose();
    }, 500);
  };
  const [yPosition, setYPosition] = React.useState(-1000);

  const _onClose = () => {
    setYPosition(-100);
    setTimeout(onClose, 500);
  };

  React.useEffect(() => {
    setYPosition(0);
  }, []);

  const linkText: string | undefined = notification?.linkText;

  if (!message && !notification) return null;

  return (
    <>
      <div
        className={clsx([styles.container, layout === AppLayout.TV && styles.tv])}
        style={{
          top: `calc(${
            layout === AppLayout.DESKTOP
              ? dimens.desktop.headerHeight
              : dimens.phone.headerHeight
          }rem + ${yPosition}px)`,
        }}
      >
        <span className={styles.desc}>{notification?.description || message}</span>
        {linkText && (
          <a href="#" onClick={onClickLink} className={styles.link} data-testid="link">
            {linkText}
          </a>
        )}
        {notification && (
          <Button
            variant="iconButton"
            className={styles.button}
            onClick={_onClose}
            testID="close"
          >
            <Close />
          </Button>
        )}
      </div>
    </>
  );
};
export default BannerNotification;
